import * as React from "react"

import { Component } from "react";
import { StaticQuery, graphql } from "gatsby"
import PageManager from "../components/PageManager"
import Seo from "../components/Seo"
import HomeLauncher from "../components/pages/HomeLauncher";

export default class IndexPage extends Component 
{ 
    render()
    {
        const page = "home";
    
        return <StaticQuery 
            query={graphql`query MetaHomeQuery {
                site {
                    siteMetadata {
                        title
                        siteUrl
                        meta {
                            page: home {
                                title
                                description
                            }
                        }
                    }
                }
            }`}
            render={data => {
                
                const { title, description } = data.site.siteMetadata.meta.page;
                const { location } = this.props;
                
                return (<PageManager page={page} data={data} windowLocation={location}>
                    <Seo page={page} title={title} description={description} />
                    <HomeLauncher />
                </PageManager>)
            }}/>
    }
}